import { MODE_LABELS } from './dilSwipeModes'; 

export default function DilSwipeModeSelect({ mode, setMode }) {
  return (
    <select
      value={mode}
      onChange={(e) => setMode(e.target.value)}
      className="h-12 px-4 py-2 rounded-xl border bg-white shadow-sm text-sm"
    >
      {Object.entries(MODE_LABELS).map(([key, label]) => (
        <option key={key} value={key}>
          {label}
        </option>
      ))}
    </select>
  );
}
